// extracted by mini-css-extract-plugin
export default {"container":"styles_container__m2V-r","fullWidth":"styles_fullWidth__IPUN-"};